import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import ArgonBox from 'component/Argon/ArgonBox';
import ArgonTypography from 'component/Argon/ArgonTypography';
import { ReactComponent as LineLogo } from 'assets/images/line_logo.svg';
import { Stack } from '@mui/material';

function ModalAlert({ open, handleClose }) {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          minWidth: 400,
          bgcolor: 'background.paper',
          // border: '2px solid #000',
          boxShadow: 24,
          border: 'none',
          borderRadius: 4,
          p: 4,
        }}
      >
        <ArgonTypography variant="h3" component="h2">
          ประกาศ
        </ArgonTypography>
        <ArgonBox mt={2} textAlign="left">
          <ArgonTypography>
            การซื้อประกันตาม&nbsp;
            <ArgonTypography component="span" sx={{ background: 'red', color: '#fff' }}>
              มติ 24 ก.ย
            </ArgonTypography>
            &nbsp;(แรงงานเถื่อน+ต่ออายุ) ต้องใช้ด้วยเลขประจำตัวคนต่างด้าว 13 หลักจากใบ Name list ของกรมจัดหางานและผู้ซื้อต้องซื้อกรมธรรม์ ผ่านระบบซื้อประกันภัยแรงงานมติ 24 ก.ย. 2567 หรือผ่านระบบซื้อประกันแบบด่วน กรมธรรม์จึงจะทำการส่งข้อมูลไปยังกรมจัดหางาน
          </ArgonTypography>
          {/* <ArgonTypography>
            
          </ArgonTypography> */}
        </ArgonBox>
        {/* <ArgonTypography sx={{ mt: 2 }}>
          หากผู้ซื้อล็อกอินด้วยชื่อบัญชีอื่นๆ และซื้อด้วยเลขประจำตัวคนต่างด้าว กรมธรรม์จะไม่สามารถลิงค์ไปยังกรมจัดฯได้
          เพราะถือเป็นการซื้อประกันแบบปกติ ขอความกรุณาติดต่อมายังบริษัทเพื่อทำการเปลี่ยนแปลง
        </ArgonTypography> */}

        <ArgonTypography sx={{ mt: 2 }} variant="h6">
          ติดต่อบริษัท
        </ArgonTypography>
        <ArgonTypography>02 026 1700</ArgonTypography>
        {/* <ArgonTypography ></ArgonTypography> */}
        <Stack direction="row" gap={1} component="a" href="https://line.me/R/ti/p/@277fakaj">
          <LineLogo width={32} height={32} />
          <ArgonTypography>Line OA</ArgonTypography>
        </Stack>
      </Box>
    </Modal>
  );
}

export default ModalAlert;
